import React from "react";
import { Container, Flex } from "@chakra-ui/react";
import { useSessionCtx, inIframe } from "utils";

import { Page } from "components/Page";
import { IFrameFooterWithLogo } from "components/Footer";

export const centeringBox = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const MaxWidth = ({ children, fullWidth, ...props }) => (
  <Container flex={1} maxW={fullWidth ? "100%" : "lg"} {...props}>
    {children}
  </Container>
);

/**
 * ContentContainer
 * @description
 * The main wrapper for any content in the widget
 * @param {object} props
 * @param {JSX.Element | JSX.Element[]} props.children
 * @returns {JSX.Element}
 */
const ContentContainer = ({ children, withoutPadding = false, fullPage, ...props }) => {
  const { sessionCtx } = useSessionCtx();
  const fullWidth = !!(sessionCtx && sessionCtx.fullWidth);
  return (
    <Flex direction="column" pb={4} pt={withoutPadding ? 0 : 4}>
      <MaxWidth
        fullWidth={fullWidth}
        {...props}
        display="flex"
        flexDirection="column"
        minHeight={fullPage ? "85vh" : null}
      >
        {children}
      </MaxWidth>
    </Flex>
  );
};

export const IframeOrFullPageWrapper = ({
  children,
  includeTosAndPrivacy = false,
  withoutPadding = false,
}) =>
  inIframe() ? (
    <ContentContainer px={withoutPadding ? 0 : 4} withoutPadding={withoutPadding}>
      {children}
      <IFrameFooterWithLogo includeTosAndPrivacy={includeTosAndPrivacy} />
    </ContentContainer>
  ) : (
    <Page>{children}</Page>
  );

export default ContentContainer;
